import ApiService from "@/common/api.service";

const PATH = "stock/products";

export const GET_STOCK_PRODUCTS = "getStockProducts";
export const GET_STOCK_PRODUCT_OPTIONS = "getStockProductOptions";
export const GET_STOCK_PRODUCT = "getStockProduct";
export const CREATE_STOCK_PRODUCT = "createStockProduct";
export const UPDATE_STOCK_PRODUCT = "updateStockProduct";
export const DELETE_STOCK_PRODUCT = "deleteStockProduct";
export const GET_STOCK_PRODUCT_UNITS = "getStockProductUnits";
export const GET_STOCK_TEMPERATURE_OPTIONS = "getStockTemperatureOptions";
export const GET_STOCK_PACKAGING_OPTIONS = "getStockPackagingOptions";
export const GET_STOCK_TAG_OPTIONS = "getStockTagOptions";
export const CREATE_STOCK_TAG = "createStockTag";
export const GET_STOCK_LOT_OPTIONS = "getStockLotOptions";

const state = {};

const getters = {};

const actions = {
  [GET_STOCK_PRODUCTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_PRODUCT_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_PRODUCT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [CREATE_STOCK_PRODUCT](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [UPDATE_STOCK_PRODUCT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [DELETE_STOCK_PRODUCT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${id}`)
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [GET_STOCK_PRODUCT_UNITS]() {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/units/options`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_TEMPERATURE_OPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/temperatures/options`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_PACKAGING_OPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/packagings/options`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_TAG_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/tags/options`, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [CREATE_STOCK_TAG](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/tags`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response.data));
    });
  },

  [GET_STOCK_LOT_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/lots/options", params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state,
  actions,
  getters,
};
